import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Input, Container, Button } from "reactstrap";
import styles from "./SelectProductsModal.module.scss";
import DataTable from "react-data-table-component";
import FilterTabsCommon from "../../../../common/FilterTabsCommon/FilterTabsCommon";
import productImg from "../../../../../assets/images/WholesalerPortalImages/CategoryManagement/productImg.png";

const packagingData = [
    { id: 11, image: productImg, name: "Blue Colored Headphones", stock: 500, sku: "34579c", price: "$35.00" },
    { id: 12, image: productImg, name: "Blue Colored Headphones", stock: 500, sku: "34579c", price: "$35.00" },
    { id: 13, image: productImg, name: "Blue Colored Headphones", stock: 500, sku: "34579c", price: "$35.00" },
    { id: 14, image: productImg, name: "Blue Colored Headphones", stock: 500, sku: "34579c", price: "$35.00" },
];

const packagingColumns = [
    {
        name: "Product",
        cell: (row) => (
            <div className={styles.productInfo}>
                <img src={row.image} alt={row.name} className={styles.productImage} />
                <div>
                    <div className={styles.productName}>{row.name}</div>
                    <div className={styles.productStock}>
                        Stock: <span>{row.stock}</span>
                    </div>
                </div>
            </div>
        ),
        width: "350px",
    },
    {
        name: "SKU",
        selector: (row) => row.sku,
    },
    {
        name: "Price",
        selector: (row) => row.price,
    },
];

const customStyles = {
    table: {
        style: {
            borderBottom: "1px solid #D9D9D9",
        },
    },
    headRow: {
        style: {
            backgroundColor: "#F2F2F2",
            borderTop: "1px solid #D9D9D9",
            borderLeft: "1px solid #D9D9D9",
        },
    },
    rows: {
        style: {
            borderLeft: "1px solid #D9D9D9",
        },
    },
    headCells: {
        style: {
            paddingLeft: "8px",
            paddingRight: "8px",
            fontSize: "15px",
            borderRight: "1px solid #D9D9D9",
        },
    },
    cells: {
        style: {
            fontSize: "15px",
            padding: "15px 8px",
            borderRight: "1px solid #D9D9D9",
        },
    },
};

const filterTabs = [
    { id: "all", label: "All" },
    { id: "recommended", label: "Recommended" },
    { id: "new", label: "New" },
];

const SelectProductsModal = ({
    isModalOpen,
    toggleModal,
    searchQuery,
    handleSearchChange,
    handleAddProducts,
}) => {
    const [activeTab, setActiveTab] = useState("all");
    const [selectedRows, setSelectedRows] = useState([]);
    
    const handleRowSelected = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const handleSave = () => {
        handleAddProducts(selectedRows);
        toggleModal();
    };

    return (
        <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg" centered className={styles.modalConatiner}>
            <ModalHeader toggle={toggleModal}>
                <p className={styles.modalHeader}>Select Products</p>
            </ModalHeader>
            <ModalBody>
                {/* Search Field */}
                <div className={styles.searchContainer}>
                    <Input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className={styles.searchInput}
                    />
                </div>

                {/* Filter Tabs */}
                <div className={styles.filterContainer}>
                    <FilterTabsCommon
                        tabs={filterTabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </div>

                {/* Total Banners and Products Table */}
                <div className={styles.productsContainer}>
                    <Container fluid className={styles.totalBanners}>
                        <span>Total Banners: 10</span>
                    </Container>

                    <Container fluid className={styles.productsTable}>
                        <DataTable
                            columns={packagingColumns}
                            data={packagingData}
                            customStyles={customStyles}
                            highlightOnHover
                            selectableRows
                            onSelectedRowsChange={handleRowSelected}
                            fixedHeader
                            fixedHeaderScrollHeight="350px"
                        />
                    </Container>
                </div>

                <div className={styles.modalFooter}>
                    <Button color="link" onClick={toggleModal} className={styles.cancelButton}>Cancel</Button>
                    <Button color="info" onClick={handleSave} className={styles.saveButton}>Save</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default SelectProductsModal;